
import { useState } from "react"
import axiosInstance from '../../../axios.config';
import { toast } from 'react-toastify';

export const useAddCourse = (courseId, lngsltd, fetchCourseSteps) => {
    const [newStepData, setNewStepData] = useState({
        courseNumber: courseId,
        stepNumber: "",
        stepTitle: ""
    });

    const [showadd, setShowAdd] = useState(false);
    const [stepNumberError, setStepNumberError] = useState('');

    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const handleSave = () => {
        if (!newStepData.courseNumber || !newStepData.stepNumber || !newStepData.stepTitle) {
            toast.error(lngsltd["Please fill in all the required fields."]);
            return;
        }
        // Check if step number is zero
        if (parseInt(newStepData.stepNumber) === 0) {
            toast.error("Step number cannot be zero.");
            return;
        }

        const newStep = {
            courseID: parseInt(newStepData.courseNumber),
            stepNo: parseInt(newStepData.stepNumber),
            stepTitle: newStepData.stepTitle,
            stepContent: "<p>Add content here</p>",
            contentType: "Text",
            description: "<p>Add Description here</p>",
        };
        axiosInstance
            .post(`/CourseStep`, newStep)
            .then((response) => {
                toast.success(lngsltd["New step added successfully."]);
                handleCloseAdd();
                fetchCourseSteps();
                //Make input fields of a Modal popup empty
                newStepData.stepNumber = "";
                newStepData.stepTitle = "";
            })
            .catch((error) => {
                toast.error(lngsltd["Error while adding new step, please refresh the page and try again."]);
                // console.error('Error adding new step:', error);
            });
    };

    const validateStepNumber = (value) => {
        if (!/^\d+$/.test(value)) {
            return lngsltd["Please enter only numbers"];
        } else if (parseInt(value) < 1 || parseInt(value) > 1000) {
            return lngsltd["Step Number should be more than 0"];
        }
        return "";
    };

    const handleStepNumberChange = (e) => {
        const value = e.target.value;
        const errorMessage = validateStepNumber(value);
        setStepNumberError(errorMessage);
        setNewStepData((prevData) => ({ ...prevData, stepNumber: value }));
    };

    return {
        showadd,
        stepNumberError,
        newStepData,
        handleStepNumberChange,
        handleSave,
        handleShowAdd,
        handleCloseAdd,
        setNewStepData,
    }

}
